import { cloneDeep } from 'lodash';
import React from 'react';

interface Props {
  data: {
    key?: string;
    value?: string;
    count?: number;
  }[];
  isSingleSelect?: boolean;
  onChange: (values: string[] | string | undefined) => void;
  selectedValues: string[];
  title: string;
}

export default function BasicCheckboxFilter({ data, onChange, isSingleSelect, selectedValues, title }: Props) {
  const onCheckboxChange = (key: string) => {
    let values = cloneDeep(selectedValues || []);
    if (isSingleSelect) {
      if (values.includes(key)) {
        values = [];
        onChange(undefined);
      } else {
        values = [key];
        onChange(key);
      }
    } else {
      if (values.includes(key)) {
        values = values.filter(x => x !== key);
      } else {
        values = [...values, key];
      }
      onChange(values);
    }
  };

  const checkBoxData = React.useMemo(() => {
    let listData = data?.filter(x => x.count || selectedValues?.includes(x.key || ''));
    selectedValues?.forEach(k => {
      if (!listData.some(x => x.key === k)) {
        listData.push({ key: k, value: k, count: 0 });
      }
    });
    return listData;
  }, [data, selectedValues]);

  if (!checkBoxData?.length) {
    return null;
  }
  return (
    <div className="sidebar__item">
      <h5 className="text-18 fw-500 mb-10">{title}</h5>
      <div className="sidebar-checkbox">
        {checkBoxData.map(filter => (
          <div key={filter.key} className="row y-gap-10 items-center justify-between">
            <div className="col text-truncate">
              <div className="form-checkbox d-flex items-center" title={filter.value || filter.key}>
                <input type="checkbox" onChange={() => onCheckboxChange(filter.key || '')} checked={selectedValues?.includes(filter.key || '')} />
                <div className={`form-checkbox__mark ${isSingleSelect ? 'rounded-full' : ''}`}>
                  <div className="form-checkbox__icon icon-check" />
                </div>
                <div className="text-15 ml-10 text-truncate">{filter.value || filter.key}</div>
              </div>
            </div>
            <div className="col-auto">
              <div className="text-15 text-light-1">{filter.count}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
